import React from 'react';
import './ApplyLoanLinksLanding.css';

const loanProviders = [
  {
    name: 'Ram Fincorp',
    url: 'https://cpadvisordigital.in/loan-application/ram-fincorp/12997730/shubhodip-chakraborty',
  },
  {
    name: 'Aditya Birla Instant Loan',
    url: 'https://cpadvisordigital.in/loan-application/aditya-birla-instant-loan/12997730/shubhodip-chakraborty',
  },
  {
    name: 'Bright Loan',
    url: 'https://cpadvisordigital.in/loan-application/bright-loans/12997730/shubhodip-chakraborty',
  },
  {
    name: 'Bajaj Market Instant',
    url: 'https://cpadvisordigital.in/loan-application/bajaj-market-instant/12997730/shubhodip-chakraborty',
  },
  {
    name: 'FDPL FatakPay Instant Loan',
    url: 'https://cpadvisordigital.in/loan-application/fdpl-fatakpay-instant-loan/12997730/shubhodip-chakraborty',
  },
  {
    name: 'My Money Bazaar',
    url: 'https://cpadvisordigital.in/loan-application/mmbmy-money-bazaar/12997730/shubhodip-chakraborty',
  },
  {
    name: 'Fatak Pay',
    url: 'https://cpadvisordigital.in/loan-application/fatak-pay/12997730/shubhodip-chakraborty',
  },
  {
    name: 'Zype',
    url: 'https://cpadvisordigital.in/loan-application/zype/12997730/shubhodip-chakraborty',
  },
  {
    name: 'Money View',
    url: 'https://cpadvisordigital.in/loan-application/moneyview/12997730/shubhodip-chakraborty',
  },
  {
    name: 'Sabka Loan',
    url: 'https://cpadvisordigital.in/loan-application/sabka-loan/12997730/shubhodip-chakraborty',
  },
  {
    name: 'Prefr Credit Vidya',
    url: 'https://cpadvisordigital.in/loan-application/prefr-credit-vidya/12997730/shubhodip-chakraborty',
  },
];

const ApplyLoanLinksLanding = () => {
  return (
    <div className="apply-loan-links-container">
      <div className="apply-loan-links-header">
        <h2>Apply for Instant Loans</h2>
        <p>Choose your preferred partner and proceed with your application.</p>
      </div>

      <div className="apply-loan-links-grid">
        {loanProviders.map((provider, index) => (
          <div key={index} className="apply-loan-links-card">
            <span className="partner-name">{provider.name}</span>
            <a
              href={provider.url}
              target="_blank"
              rel="noopener noreferrer"
              className="apply-loan-links-apply-btn"
            >
              Apply Now &rarr;
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApplyLoanLinksLanding;